import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

export const GetAPIClients = graphql(/* GraphQL */ `
  query getAPIClients {
    apiClients {
      clients {
        clientId
        clientName
        clientSecret
        createdAt
        redirectUris
        privacyPolicyUri
        logoUri
        scopes {
          name
        }
      }
      maxClients
      canUpgradeForMore
    }
  }
`)

export type APIClient = ResultOf<
  typeof GetAPIClients
>['apiClients']['clients'][number]

type UseAPIClientsResult = {
  clients: APIClient[]
  maxClients: number
  canUpgradeForMore: boolean
  isLoading: boolean
  hasError: boolean
  refetch: () => Promise<void>
}

/**
 * Custom hook to fetch API clients for the current account.
 */
export const useAPIClients = (): UseAPIClientsResult => {
  const { data, loading, error, refetch } = useQuery(GetAPIClients, {
    fetchPolicy: 'cache-and-network',
  })

  const clients = data?.apiClients?.clients ?? []
  const maxClients = data?.apiClients?.maxClients ?? 1
  const canUpgradeForMore = data?.apiClients?.canUpgradeForMore ?? true

  return {
    clients,
    maxClients,
    canUpgradeForMore,
    isLoading: loading,
    hasError: !!error,
    refetch: async (): Promise<void> => {
      await refetch()
    },
  }
}
